import { ANIMATION_START_Y } from "@utils/animation";
import { AnimatePresence, motion } from "framer-motion";
import { FC, MouseEventHandler, useEffect, useRef, useState } from "react";

import Icon from "@/components/ui/Icon/Icon";

import "./map.css";

//https://github.com/alex1998dmit/map_airbnb
type MapPointProps = {
  text: string;
  icon?: string;
  visible?: boolean;
  index: number;
  className?: string;
  iconClassName?: string;
  hideText?: boolean;
  selected?: boolean;
  clickHandler?: MouseEventHandler<HTMLDivElement>;
};

const MapPoint: FC<MapPointProps> = ({
  text,
  icon,
  visible = true,
  index,
  className,
  hideText = false,
  iconClassName,
  selected = false,
  clickHandler,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(this: Document, event: MouseEvent) {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [containerRef]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          // style={{ originX: 0.5, originY: 1 }}
          initial={{ opacity: 0, y: ANIMATION_START_Y, x: "-50%" }}
          exit={{ opacity: 0, y: ANIMATION_START_Y, x: "-50%" }}
          // animate={{ opacity: selected ? 1 : 0.7, y: 0 }}
          animate={{ opacity: 1, y: "-100%", x: "-50%" }}
          /* whileHover={{
            scale: 1.2,
          }} */
          transition={{ delay: 0.1 * (index / 2) }}
          className={className ?? `poi-info-window`}
          ref={containerRef}
          title={text}
          onClick={clickHandler}
        >
          {icon && <Icon className={`stroke-black ${iconClassName ? iconClassName : ""}`} size="20" name={icon} />}
          {!hideText && <div>{text}</div>}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MapPoint;
